module.exports = __webpack_public_path__ + "static/media/khyros-work-pattern-framed.e9c74a78.png";